//loading
  $(function(){
	$(".loading").fadeOut();	 
	});
	//一定時間後強制的にロード画面を非表示
	$(function(){
	  setTimeout('stopload()',6000);
	});
	function stopload(){
	$(".loading").fadeOut();	 
	}

// scrollSmooth
$(document).ready(function(){
	$('a[href^="#"]:not(".not-scr")').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;

		if (href !== "#lp_top") {
			position -= 30;
		}
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
});


function sp() {
	wd = $(window).width();
	if(wd <= 767){
		$("#btn-contact").hide();
		$(window).on("scroll", function() {
			if ($(this).scrollTop() > 100) {
				$("#btn-contact").fadeIn("fast");
			} else {
				$("#btn-contact").fadeOut("fast");
			}
		});
	}else{
		$("#btn-contact").fadeIn("fast");
	}
  }
  
  $(function(){
	sp();
  });
  
  $(window).resize(function(){
	sp();
  });

//AOS
 AOS.init({
      duration: 1000,
      once: true
      
    });
	

//PCナビ調整用
function updateNavClass() {
	const nav = document.getElementById('local_nav');
	if (!nav) return; // 要素が存在しない場合は何もしない
  
	if (window.innerWidth >= 1024 && window.innerHeight <= 768) {
	  nav.classList.add('lp01-f-vh');
	} else {
	  nav.classList.remove('lp01-f-vh');
	}
  }
  
  // 初回チェック
  updateNavClass();
  
  // リサイズ時にチェック
  window.addEventListener('resize', updateNavClass);


  //背景エフェクト用
document.addEventListener("DOMContentLoaded", () => {
  const boxes = document.querySelectorAll(".sec-episode");
  const images = [
    "https://cdn.shopify.com/s/files/1/0685/5078/7314/files/lp_original-story_bg02.png?",
    "https://cdn.shopify.com/s/files/1/0685/5078/7314/files/lp_original-story_bg03.png?",
    "https://cdn.shopify.com/s/files/1/0685/5078/7314/files/lp_original-story_bg04.png?"
  ];

  const layers = [0, 1].map(() => {
    const layer = document.createElement("div");
    layer.classList.add("js-bg-layer");
    document.body.prepend(layer);
    return layer;
  });

  let activeLayer = 0;
  let currentIndex = -1;

  const updateBackground = () => {
    let nextIndex = -1;

    boxes.forEach((box, index) => {
      const rect = box.getBoundingClientRect();

      if (rect.top <= window.innerHeight / 2 && rect.bottom > 0) {
        nextIndex = index;
      }
    });

    if (nextIndex === currentIndex) return;

    currentIndex = nextIndex;

    if (nextIndex === -1 || !images[nextIndex]) {
      layers[activeLayer].style.opacity = "0";
      return;
    }

    const nextLayer = 1 - activeLayer;

    layers[nextLayer].style.backgroundImage =
      `url("${images[nextIndex]}")`;

    layers[nextLayer].style.opacity = "0";

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        layers[nextLayer].style.opacity = "0.2";
        layers[activeLayer].style.opacity = "0";
        activeLayer = nextLayer;
      });
    });
  };

  window.addEventListener("scroll", updateBackground, {
    passive: true
  });

  updateBackground();
});


// スクロールでheader-innerの不透明度を0にする
$(window).on('scroll', function() {
  var scroll = $(window).scrollTop();

  if (window.matchMedia('(max-width: 767px)').matches) {
    var opacity = Math.max(1 - (scroll / 300), 0);
    $('.header-inner').css('opacity', opacity);
  } else {
    $('.header-inner').css('opacity', 1);
  }
});


// anime
// img scale
const images = document.querySelectorAll('.js-scroll-image');

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.2
});

images.forEach((image) => {
  observer.observe(image);
});

// fade-up
const fadeUpItems = document.querySelectorAll('.js-fade-up');

const fadeUpObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      fadeUpObserver.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.2
});

fadeUpItems.forEach((item) => {
  fadeUpObserver.observe(item);
});

// blur
const fadeBlurItems = document.querySelectorAll('.js-fade-blur');

const fadeBlurObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      fadeBlurObserver.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.2
});

fadeBlurItems.forEach((item) => {
  fadeBlurObserver.observe(item);
});